<template>
  <Card>
    <Flex gap-3 justify-between>
      <div class="flex-1 gap-3">
        <div class="flex gap-3 items-end max-w-[80%]">
          <slot class="border-r pr-3" name="filters"></slot>
        </div>
      </div>
      <div class="flex justify-end items-end gap-x-3">
        <slot name="buttons"></slot>
      </div>
    </Flex>
  </Card>
  <!-- <section class="p-3 flex  bg-white border rounded-lg mb-3 w-full min-h-[80px]"> -->
  <!-- </section> -->
</template>
